import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from "@angular/common/http";
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CentrosMantencionService {

  constructor(private readonly http: HttpClient) { }

  listarCenrtroMantenedores(): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    return this.http.post<any[]>(
      `${environment.API_DOMAINS.OTIC_CR}/centros/listarCentro`,
      {},
      { headers }
    );
  }

  listarCentroMantenedor(limit: number ,offset: number,centNombreCentro?: string,centCodigoCompania?: string,centActivado?: boolean): Observable<any> {
    const headers = { 'Content-Type': 'application/json' };
  
    const body: any = {
      limit,
      offset,
      centNombreCentro: centNombreCentro || '',
      centCodigoCompania: centCodigoCompania || '',
    };
  
    if (centActivado !== undefined) {
      body.centActivado = centActivado;
    }
  
    console.log('Cuerpo enviado al backend:', body);
  
    return this.http.post<any>(
      `${environment.API_DOMAINS.OTIC_CR}/centros/listarCentro`,
      body,
      { headers })
    
  }
  
  agregarCentroMantenedor(centro: any): Observable<any> {
    const headers = { 'Content-Type': 'application/json' };
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/centros/agregarCentro`,centro,{ headers });
  }

  editarCentro(centroActualizado: any): Observable<any> {
    const headers = { 'Content-Type': 'application/json' };
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/centros/actualizarCentro`,centroActualizado,{ headers });
  }
 
  obtenerCentroPorCodigo(codigo: string): Observable<boolean> {
    return this.http.get<any>(`${environment.API_DOMAINS.OTIC_CR}/centros/getCentroCodigo/${codigo}`)
      .pipe(
        map((response) => response.exists) // Extrae el valor de "exists"
      );
  }
  
  obtenerCentroPorNombre(nombre: string): Observable<boolean> {
    return this.http.get<any>(`${environment.API_DOMAINS.OTIC_CR}/centros/getCentroNombre/${nombre}`)
      .pipe(
        map((response) => response.exists) // Extrae el valor de "exists"
      );
  }

  listarSociedadesYSegmentos(): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    return this.http.get<any[]>(`${environment.API_DOMAINS.OTIC_CR}/sociedades/listarSociedadesYSegmentos`,{ headers });
  }
}
